import packageInfo from '../../package.json';

export const environment = {
    production: true,
    environmentName: 'Production',
    apiUrl: 'https://pixelied.com',
    releaseName: `pixelied-client-production@${packageInfo.version}`,
    stripePublishableKey: 'pk_live_hHLWuDjnuiG4jrPir7xcDmaA',
    gtmId: 'GTM-KNV558L'
};